import {CdkConnectedOverlay, CdkOverlayOrigin} from "@angular/cdk/overlay"
import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {TemplateAddMaterialComponent} from "@app/template-editor/components/template-add-material/template-add-material.component"
import {TemplateAddSceneItemComponent} from "@app/template-editor/components/template-add-scene-item/template-add-scene-item.component"
import {TemplateAddProductComponent} from "@app/template-editor/components/template-add-product/template-add-product.component"
import {TemplateAddOtherComponent} from "@app/template-editor/components/template-add-other/template-add-other.component"
import {TemplateAddSceneComponent} from "@app/template-editor/components/template-add-scene/template-add-scene.component"

type SectionType = "scene" | "products" | "materials" | "scene-item" | "other"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-add",
    templateUrl: "./template-add.component.html",
    styleUrl: "./template-add.component.scss",
    imports: [
        CdkConnectedOverlay,
        CdkOverlayOrigin,
        TemplateAddMaterialComponent,
        TemplateAddSceneItemComponent,
        TemplateAddProductComponent,
        TemplateAddOtherComponent,
        TemplateAddSceneComponent,
    ],
})
export class TemplateAddComponent {
    readonly $currentSection = signal<SectionType | undefined>(undefined)

    toggleSection(section: SectionType) {
        this.$currentSection.update((previousSection) => (previousSection === section ? undefined : section))
    }
}
